// extracted by mini-css-extract-plugin
export default {"header":"FormHeader_header__oVRMq","title":"FormHeader_title__Vxn2D"};